import { CanvasObjectProperties, CanvasObjectStyles } from '@y42/json-schema';

export const defaultCanvasObjectProperties: CanvasObjectProperties = {
  resizable: true,
  movable: true,
  selectable: true,
  rotatable: true,
};

export const defaultCanvasGenericStyles: CanvasObjectStyles = {
  'background-color': 'none',
  'border-color': 'none',
  'border-style': 'none',
  'border-width': '0',
  'border-radius': '0',
  filter: 'drop-shadow(0px 0px 0px #939393)',
};
